import React from "react";
import { Link } from "react-router-dom";
import { ChevronRight } from "lucide-react";

export default function TocSidebar({ chapters, activeId, onNavigate }) {
  return (
    <aside
      className="lg:sticky lg:top-24 lg:self-start max-h-[calc(100vh-7rem)] overflow-y-auto scroll-fade-y pr-2"
      data-testid="toc-sidebar"
    >
      <div className="eyebrow mb-4">Table of Contents</div>
      <nav className="border-l border-current/30">
        {chapters.map((c, i) => (
          <button
            key={c.id}
            type="button"
            onClick={() => onNavigate(c.id)}
            className={"toc-link w-full text-left " + (activeId === c.id ? "active" : "")}
            data-testid={`toc-link-${c.id}`}
          >
            <span className="opacity-50 mr-2">{String(i + 1).padStart(2, "0")}</span>
            {c.title}
          </button>
        ))}
      </nav>
      <Link
        to="/#signup"
        className="btn-ghost mt-8 w-full justify-center"
        data-testid="toc-cta-join"
      >
        Join NewWaysToday <ChevronRight size={14} />
      </Link>
    </aside>
  );
}
